import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  private trackingKeys: string[] = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content',
    'gclid', 'fbclid', 'msclkid', 'ttclid', 'scid', 'aff_id', 'aff_click_id', 'sub_id', 'session_id'
  ];

  constructor() { }

  pushEvent(eventName: string, eventData: any): void {
    // Check if the window and dataLayer exist
    if (window && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: eventName,
        ...eventData,
      });
    }
  }

  getTrackingParamsFromDataLayer(): Record<string, string> {
    const keys = [
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content',
      'gclid', 'fbclid', 'msclkid', 'ttclid', 'scid', 'aff_id', 'aff_click_id', 'sub_id', 'session_id'
    ];

    const dataLayer = (window as any).dataLayer;
    if (!Array.isArray(dataLayer)) return {};

    const result: Record<string, string> = {};

    // Traverse backwards to get latest values
    for (let i = dataLayer.length - 1; i >= 0; i--) {
      const item = dataLayer[i];
      if (typeof item !== 'object') continue;

      for (const key of keys) {
        if (item[key] && !result[key]) {
          result[key] = item[key];
        }
      }

      // Stop early if all keys are found
      if (Object.keys(result).length === keys.length) break;
    }

    return result;
  }
}
